"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _createIcon = _interopRequireDefault(require("../Icon/createIcon"));

/* eslint-disable */
var _default = (0, _createIcon.default)( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M17.466 6.177c.6-.05 1.38-.38 1.839-.61l.446-.241c-.262.698-.617 1.245-1.165 1.66-.12.091-.241.216-.393.274.779.001 1.421-.345 2.032-.533a5.628 5.628 0 01-1.218 1.385l-.56.438c.01.813-.012 1.587-.167 2.27-.897 3.968-3.272 6.662-7.033 7.816-1.35.414-3.533.584-5.08.206-.767-.188-1.46-.4-2.111-.68a8.31 8.31 0 01-1.016-.515l-.315-.19c.349.011.757.106 1.147.044.353-.057.7-.042 1.025-.112.812-.175 1.533-.407 2.154-.765.302-.174.759-.378.973-.628a3.083 3.083 0 01-1.069-.19c-1.162-.403-1.837-1.145-2.277-2.26.351.038 1.365.127 1.603-.069-.444-.024-.87-.277-1.174-.464-.934-.576-1.696-1.541-1.69-3.027l.368.172c.234.097.473.15.753.206.118.024.354.093.49.043-.198-.207-.492-.345-.675-.567-.599-.734-1.16-1.863-.805-3.207.09-.341.233-.643.385-.92.087.152.243.258.342.378.306.374.684.71 1.068 1.006 1.312 1.01 2.492 1.63 4.388 2.09a6.996 6.996 0 001.612.206c-.161-.463-.11-1.212.018-1.66.32-1.126 1.014-1.938 2.032-2.373a4.39 4.39 0 01.797-.24l.438-.052c1.39-.024 2.13.475 2.838 1.11z"
})), "0 0 24 24", "Twitter");

exports.default = _default;